<template>
	<page class="page">
		<v-row justify="center">
			<v-col lg="6">
				<v-card>
					<v-card-text v-if="lottery.logo">
						<v-img c width="200px" :src="lottery.logo"></v-img>
					</v-card-text>
					<v-card-title class="justify-center">
						<h1 class="text-h1 text-center">
							{{ lottery.title }}
						</h1>
					</v-card-title>
					<v-card-subtitle v-if="lottery.subtitle" class="justify-center">
						<h3 class="text-center">{{lottery.subtitle}}</h3></v-card-subtitle>
					<loader v-if="inProgress"/>
					<v-card v-if="datePast">
						<v-card-title class="justify-center align-center">
							<h2> {{ datePast }}</h2>
						</v-card-title>
					</v-card>
					<v-stepper v-else alt-labels v-model="step">
						<v-stepper-header>
							<v-stepper-step step="1" :editable="step != 4">
								בחירת חבילת כרטיסים
							</v-stepper-step>

							<v-divider></v-divider>
							<v-stepper-step step="2" :editable="!!cPackage.id">
								הרשמה
							</v-stepper-step>

							<v-divider></v-divider>

							<v-stepper-step step="3">
								תשלום
							</v-stepper-step>
							<v-divider></v-divider>

							<v-stepper-step step="4">
								מספרי הכרטיסים
							</v-stepper-step>

						</v-stepper-header>
						<v-stepper-items>
							<v-stepper-content step="1">
								<v-row justify="center">
									<v-col lg="10" class="text-center">
										<v-card>
											<v-card-text>
												<packages-cards @selected="selectPackage" :lottery="lottery"/>
											</v-card-text>
										</v-card>
									</v-col>
								</v-row>
							</v-stepper-content>
						</v-stepper-items>
						<v-stepper-items>
							<v-stepper-content step="2">
								<v-row justify="center">
									<v-col lg="10" class="text-center">
										<v-card>
											<v-card-text>
												<package-card :cPackage="cPackage"/>
											</v-card-text>
											<v-card-text>
												<register-client-form :referrer="referrer" @register="onRegister"/>
											</v-card-text>
										</v-card>
									</v-col>
								</v-row>
							</v-stepper-content>
						</v-stepper-items>
						<v-stepper-items>
							<v-stepper-content step="3">
								<v-row>
									<v-col class="text-center">
										<v-card>
											<v-card-title class="justify-center">
												<h1 class="text-h1 text-center">
													תשלום
												</h1>
											</v-card-title>
											<!--                                            <v-card-text>-->
											<!--                                            </v-card-text>-->
											<v-card-text>
												<nedarimplus-iframe :cPackage="cPackage" v-if="step ==3"
													@success="onPaymentSuccess" :client="client"
													:amount="amount"/>
											</v-card-text>
										</v-card>
									</v-col>
								</v-row>
							</v-stepper-content>
						</v-stepper-items>
						<v-stepper-items>
							<v-stepper-content step="4">
								<v-row>
									<v-col class="text-center">
										<v-card>
											<share-card v-if="lottery" :link="link" :title-link="lottery.title"
												:subTitle="lottery.description"/>
										</v-card>
									</v-col>
								</v-row>
								<v-row>
									<v-col class="text-center">
										<v-card>
											<card-list :thanks="cPackage.thanks_words"/>
										</v-card>
									</v-col>
								</v-row>
							</v-stepper-content>
						</v-stepper-items>
					</v-stepper>
				</v-card>
			</v-col>
		</v-row>
	</page>
</template>

<script>
	import {types} from "../store/modules/Lottery.module";
	import {types as cardTypes} from "../store/modules/Card.module";
	import {types as PackageType} from "../store/modules/Package.module";
	import Loader from "../components/loader";
	import RegisterClientForm from "./clients/RegisterClientForm";
	import NedarimplusIframe from "../nedarimplus/NedarimplusIframe";
	import CardList from "./cards/CardList";
	import PackagesCards from "./packages/PackagesCards";
	import PackageCard from "./packages/PackageCard";
	import ShareCard from "../components/ShareCard";

	export default {
		name: "welcome-view",
		components: {
			ShareCard,
			PackageCard,
			PackagesCards, CardList, NedarimplusIframe, RegisterClientForm, Loader
		},
		props: [],
		data() {
			return {
				inProgress: true,
				step: 1,
				amount: 1,
				datePast: null
			};
		},
		computed: {
			lotteryId() {
				return this.$route.params.lotteryId;
			},
			lottery() {
				return this.$store.state.LotteryModule.lottery;
			},
			client() {
				return this.$store.state.ClientModule.client;
			},
			cPackage() {
				return this.$store.state.PackageModule.package;
			},
			link() {
				return document.location.origin + "/?token=" + this.client.token;
			},
			referrer() {
				return document.referrer;
			}
		},
		async created() {
			try {
				let lottery = null;
				if (this.lotteryId) {
					lottery = await this.$store.dispatch(types.GET, this.lotteryId);

				} else {
					lottery = await this.$store.dispatch(types.GET);
				}
				if (this.$route.query.package) {
					let cPackage = lottery.packages.find(p => p.hash === this.$route.query.package);
					if (cPackage) {
						this.selectPackage(cPackage);
					}
				}
			} catch (e) {
				this.datePast = e.response.data.message;
			}
			this.inProgress = false;
		},
		methods: {
			selectPackage(selectedPackage) {
				this.$store.commit(PackageType.GET, selectedPackage);
				this.step++;
			},
			onRegister({amount}) {
				this.amount = +amount;
				this.step++;
			},
			async onPaymentSuccess({ID}) {
				await this.$store.dispatch(cardTypes.SAVE, {
					client_id: this.client.id,
					lottery_id: this.lottery.id,
					package_id: this.cPackage.id,
					transaction: ID
				});
				this.step++;
			}
		},
	};
</script>

<style scoped>
    .page {
        background-color: #092C58;
    }
</style>
